<script setup>
  defineProps(['count']);
</script>

<template>
  <div class="results-count">
    Count:
    {{ count.toLocaleString() }}
  </div>
</template>

<style scoped lang="scss">
  .results-count {
    font-size: 12px;
    text-align: center;
  }
</style>
